module.exports = __webpack_public_path__ + "img/peroneo_sx.b7ec9625.png";